export const FPS = 30;
